// Shared form-data helpers for the Artwork CMS.
// Lives in its own module so the same shape is referenced by:
//   - ArtworkManager (parent state)
//   - ArtworkForm (the controlled form panel)
// and so neither has to re-declare the (long) defaults.

export const INITIAL_FORM_DATA = {
  artistId: '',
  artistName: '',
  title: '',
  year: '',
  medium: '',
  dimensions: '',
  price: '',
  priceDisplay: '',
  galleryName: 'Zebra One Gallery',
  imageUrl: '',
  description: '',
  altText: '',
  available: true,
  status: 'available',
  on_hold_reason: '',
  featured: false,
  category: '',
  tags: [],
  edition: '',
  provenance: '',
  exhibition_history: '',
  literature: '',
  vatScheme: 'standard',
};

// Map a server Artwork document into the controlled-form shape.
// Centralised here so the field list stays in sync with INITIAL_FORM_DATA.
export const formDataFromArtwork = (artwork) => ({
  artistId: artwork.artistId || '',
  artistName: artwork.artistName || '',
  title: artwork.title || '',
  year: artwork.year || '',
  medium: artwork.medium || '',
  dimensions: artwork.dimensions || '',
  price: artwork.price || '',
  priceDisplay: artwork.priceDisplay || '',
  galleryName: artwork.galleryName || 'Zebra One Gallery',
  imageUrl: artwork.imageUrl || '',
  description: artwork.description || '',
  altText: artwork.altText || '',
  available: artwork.available !== false,
  status: artwork.status || (artwork.available === false ? 'sold' : 'available'),
  on_hold_reason: artwork.on_hold_reason || '',
  featured: artwork.featured || false,
  category: artwork.category || '',
  tags: artwork.tags || [],
  edition: artwork.edition || '',
  provenance: artwork.provenance || '',
  exhibition_history: artwork.exhibition_history || '',
  literature: artwork.literature || '',
  vatScheme: artwork.vatScheme || 'standard',
});
